export const EXTERNAL_SSO_REDIRECT_URL_METADATA_KEY =
  'external_sso_redirect_url';
export const EXTERNAL_SSO_CODE_PARAM = 'external_sso_code';
export const EXTERNAL_SSO_START_CODE_PARAM = 'external_sso_start_code';
export const EXTERNAL_SSO_CODE_MESSAGE_TYPE = 'EXTERNAL_SSO_CODE';
export const POPUP_NAME = 'external-sso';

export function postExternalSsoCodeToOpener(code: string): boolean {
  // An IdP launcher tile leaves its own cross-origin opener on our tab.
  if (!window.opener || window.name !== POPUP_NAME) {
    return false;
  }

  window.opener.postMessage(
    { type: EXTERNAL_SSO_CODE_MESSAGE_TYPE, code },
    window.location.origin
  );
  window.close();

  return true;
}
